import React from "react";

import styled from "styled-components";

import Text from "components/atoms/text/Text";

const OutlineContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-height: 0;
    padding: 4px 8px 12px;
    overflow: auto;
`;

const OutlineItem = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 30px;
    padding: 5px 8px 5px ${({ $level }) => 8 + Math.max(0, $level - 1) * 12}px;
    border: 0;
    border-radius: 4px;
    background-color: ${({ $active }) => ($active ? "var(--color-ButtonHover4)" : "transparent")};
    color: ${({ $active }) => ($active ? "var(--color-Key)" : "var(--color-SubBlack)")};
    cursor: pointer;
    text-align: left;

    &:hover {
        background-color: var(--color-ButtonHover4);
    }
`;

const OutlineTitle = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: ${({ $level }) => ($level === 1 ? "1.3rem" : "1.2rem")};
    font-weight: ${({ $level }) => ($level === 1 ? 600 : 400)};
`;

const EmptyText = styled(Text).attrs({
    variant: "body-sm-400",
    color: "var(--color-Grey1)",
})`
    padding: 8px;
    line-height: 1.5;
`;

function renderOutlineItems(items, activeOutlineId, onSelect) {
    return items.map((item) => (
        <React.Fragment key={item.id}>
            <OutlineItem
                type="button"
                aria-current={activeOutlineId === item.id ? "true" : undefined}
                $active={activeOutlineId === item.id}
                $level={item.level}
                title={item.title}
                onClick={() => onSelect?.(item)}
            >
                <OutlineTitle $level={item.level}>{item.title}</OutlineTitle>
            </OutlineItem>
            {item.children?.length ? renderOutlineItems(item.children, activeOutlineId, onSelect) : null}
        </React.Fragment>
    ));
}

function NoteOutlinePanel({ activeOutlineId, items = [], onSelect }) {
    if (!items.length) {
        return <EmptyText>제목 1, 제목 2, 제목 3을 사용하면 목차가 표시됩니다.</EmptyText>;
    }

    return <OutlineContainer>{renderOutlineItems(items, activeOutlineId, onSelect)}</OutlineContainer>;
}

export default NoteOutlinePanel;
